
export default function Benefits() {
  const benefits = [
    {
      number: '01',
      title: '입회비 100% 반환',
      subtitle: '유지비 제로',
      description: '5년 만기 후 전액 환급',
      highlight: '3,300만원부터 상품 선택 가능',
      image: 'https://public.readdy.ai/ai/img_res/527f57e30ed3afa62658bca3156a10fc.jpg'
    },
    {
      number: '02',
      title: '연회비 5년간 면제',
      subtitle: '유지비 제로',
      description: '동계 프로모션 기간 가입자 한정 혜택',
      highlight: '최대 1,000만원 혜택',
      image: 'https://readdy.ai/api/search-image?query=two%20golfers%20walking%20on%20a%20beautiful%20premium%20golf%20course%20at%20sunrise%2C%20lush%20green%20fairway%20with%20morning%20dew%2C%20mountains%20in%20the%20distance%2C%20calm%20and%20luxurious%20atmosphere%2C%20soft%20warm%20light%2C%20wide%20open%20landscape%2C%20professional%20golf%20photography%2C%20vibrant%20colors%2C%20high%20resolution&width=1200&height=600&seq=benefit_02_golf&orientation=landscape'
    },
    {
      number: '03',
      title: '그린피 지원',
      subtitle: '',
      description: '전국 모든 골프장 이용 시',
      highlight: '4인 그린피 50% 또는 100% 환급',
      image: 'https://readdy.ai/api/search-image?query=group%20of%20four%20golfers%20enjoying%20a%20round%20on%20a%20stunning%20Korean%20golf%20course%2C%20lush%20green%20hills%20and%20fairways%2C%20bright%20sunny%20day%2C%20blue%20sky%20with%20white%20clouds%2C%20premium%20country%20club%20setting%2C%20joyful%20and%20relaxed%20mood%2C%20wide%20angle%20landscape%20shot%2C%20vivid%20natural%20colors%2C%20high%20quality%20photography&width=1200&height=600&seq=benefit_03_golf&orientation=landscape'
    }
  ];

  return (
    <section id="benefits" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-3 md:mb-4 leading-tight">
            스마트스코어를 선택해야 하는 이유
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            안정적인 투자와 최고의 혜택을 동시에
          </p>
        </div>

        <div className="space-y-5 md:space-y-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-xl"
              style={{ minHeight: '260px' }}
            >
              <div className="absolute inset-0">
                <img
                  src={benefit.image}
                  alt={benefit.title}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-transparent"></div>
              </div>

              <div className="relative z-10 p-6 sm:p-8 md:p-12 flex items-center min-h-[260px] md:min-h-[400px]">
                <div className="max-w-xl text-left">
                  <div className="text-3xl sm:text-4xl md:text-6xl font-bold text-white/30 mb-2 md:mb-4">{benefit.number}</div>
                  <h3 className="text-xl sm:text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2">{benefit.title}</h3>
                  {benefit.subtitle && (
                    <p className="text-base sm:text-lg md:text-2xl font-bold text-white mb-2 md:mb-4">{benefit.subtitle}</p>
                  )}
                  <p className="text-sm sm:text-base md:text-xl text-white/90 mb-2 md:mb-4">{benefit.description}</p>
                  <p className="text-base sm:text-lg md:text-2xl font-bold text-blue-300">{benefit.highlight}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
